import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=d6f5b178&scoped=true&"
import script from "./Template.ts?vue&type=script&lang=ts&"
export * from "./Template.ts?vue&type=script&lang=ts&"
import style0 from "./templates.scss?vue&type=style&index=0&id=d6f5b178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f5b178",
  null
  
)

export default component.exports